import { toFixed } from '../../../core/services/utils/numbers';

/** Calcula o percentual de participação da quantidade projetada sobre a quantidade potencial */
export function calcularQuantidadeProjetadaPerc(quantidadeProjetada: number, quantidadePotencial: number): number {
    quantidadeProjetada = quantidadeProjetada && !isNaN(quantidadeProjetada) ? Number(quantidadeProjetada) : 0;
    quantidadePotencial = quantidadePotencial && !isNaN(quantidadePotencial) ? Number(quantidadePotencial) : 0;

    if (quantidadePotencial === 0) {
        return 0;
    }

    const perc = (quantidadeProjetada / quantidadePotencial) * 100;
    return toFixed(perc, 2);
}

/** Calcula o percentual de participação do peso projetado sobre peso potencial */
export function calcularPesoProjetadoPerc(pesoProjetado: number, pesoPotencial: number): number {
    pesoProjetado = pesoProjetado && !isNaN(pesoProjetado) ? Number(pesoProjetado) : 0;
    pesoPotencial = pesoPotencial && !isNaN(pesoPotencial) ? Number(pesoPotencial) : 0;

    if (pesoPotencial === 0) {
        return 0;
    }

    const perc = (pesoProjetado / pesoPotencial) * 100;
    return toFixed(perc, 2);
}

/** Calcula o valor projetado multiplicando a quantidade pelo valor unitário */
export function calcularValorProjetado(quantidadeProjetada: number, valorUnitario: number, precision = 4): number {
    quantidadeProjetada = quantidadeProjetada && !isNaN(quantidadeProjetada) ? Number(quantidadeProjetada) : 0;
    valorUnitario = valorUnitario && !isNaN(valorUnitario) ? Number(valorUnitario) : 0;

    const valorProjetado = quantidadeProjetada * valorUnitario;
    return toFixed(valorProjetado, precision);
}

/** Calcula o percentual de participação do valor projetado sobre o valor potencial */
export function calcularValorProjetadoPerc(valorProjetado: number, valorPotencial: number): number {
    valorProjetado = valorProjetado && !isNaN(valorProjetado) ? Number(valorProjetado) : 0;
    valorPotencial = valorPotencial && !isNaN(valorPotencial) ? Number(valorPotencial) : 0;

    if (valorPotencial === 0) {
        return 0;
    }

    const perc = (valorProjetado / valorPotencial) * 100;
    return toFixed(perc, 2);
}
